<template>
  <!-- 报警信息 -->
  <div class="infoCode">
    <!-- 状态码 -->
    <div class="head">
      <div class="code">
        <div>状态码:</div>
        <div>12</div>
      </div>
      <div class="time">
        <div>2022-12-13</div>
        <div>15:47</div>
      </div>
    </div>
    <!-- 状态内容 -->
    <div class="content">
      <div class="status">状态消息</div>
      <div class="status-info">
        托盘放反或者防反气缸无法伸出或者检测防反传感器状态错误
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.infoCode {
  width: 100%;
  height: 90px;
  margin-top: 14px;
  background: url("../../assets/images/infoCode-bg.png") no-repeat 0 0;
  background-size: 100% 100%;

  .head {
    height: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;

    .code {
      display: flex;

      div {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }
    }

    .time {
      display: flex;

      div {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        margin-left: 12px;
      }
    }
  }

  .content {
    width: 100%;
    height: calc(100% - 28px);
    padding: 4px 12px;
    overflow-y: auto;

    .status {
      font-size: 14px;
      font-weight: 400;
      color: #37ffe9;
    }

    .status-info {
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>